import PropTypes from 'prop-types';
import cc from 'classcat';

import styles from './styles.module.scss';

const BorderedRow = ({ stacked, className, children, onClick }) => (
  <div
    className={cc([
      styles.container,
      {
        [styles.stacked]: stacked,
      },
      className,
    ])}
    onClick={onClick}
  >
    {children}
  </div>
);

BorderedRow.propTypes = {
  stacked: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

BorderedRow.defaultProps = {
  stacked: true,
};

export default BorderedRow;
